import ApiClient from '@/ApiClient';
import { queryOptions } from '@tanstack/vue-query';

// `companyId` is a ref/computed used as the cache discriminator; vue-query deep-unwraps
// refs inside the key, so pass it without `.value`. The report array lives at
// `response.data`; normalise to `[]` here so consumers always get an array.
export const getEmployeePaymentsReport = companyId =>
  queryOptions({
    queryKey: ['employee_payments_report', companyId],
    queryFn: async () => (await ApiClient.getEmployeePaymentsReport())?.data ?? [],
  });
